import { ISliderData } from "../../exports/interfaces";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const Carousel = (props: { sliderData: ISliderData[] }) => {
  const images = props.sliderData?.map((data) => {
    return {
      id: data?.id,
      title: data?.attributes?.Title,
      image: data?.attributes?.Image?.data?.attributes?.url,
      description: data?.attributes?.Description,
      Link_To: data?.attributes?.Link_To
        ? data.attributes.Link_To.toLowerCase()
            .replace("page", "")
            .trim()
            .replace(/\s+/g, "-")
        : "/",
    };
  });
  return (
    <section className="main-slider main-slider-two">
      <div
        className="swiper-container thm-swiper__slider"
        data-swiper-options='{"slidesPerView": 1, "loop": true,
    "effect": "fade",
     "pagination": {
        "el": "#main-slider-pagination",
        "type": "bullets",
        "clickable": true
      },
    "navigation": {
        "nextEl": "#main-slider__swiper-button-next",
        "prevEl": "#main-slider__swiper-button-prev"
    },
    "autoplay": {
        "delay": 5000
    }}'
        style={{ height: "55em" }}
      >
        <div className="swiper-wrapper custom-swiper-wrapper">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000 }}
            style={{ height: "100%", width: "100%" }}
            className="custom-swiper"
          >
            {images?.map((image) => {
              return (
                <SwiperSlide key={image.id}>
                  <div className="swiper-slide">
                    <div
                      className="image-layer"
                      style={{
                        backgroundImage: image?.image && `url(${process.env.REACT_APP_strapiUrl}${image?.image})`,
                      }}
                    ></div>
                    {/* <div className="container" style={{height: '156dvh'}}> */}
                    <div className="container">
                      <div className="row">
                        <div className="col-xl-12">
                          <div className="main-slider__content">
                            <h2>{image?.title}</h2>
                            <p>{image?.description}</p>
                            <a href={`${image?.Link_To}`} className="thm-btn">
                              Discover More
                            </a>
                            {/* <div className="main-slider-two-map">
                              <img
                                src="assets/images/shapes/main-slider-two-map.png"
                                alt=""
                              />
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>

        {/* <div className="swiper-pagination" id="main-slider-pagination"></div>
                <div className="main-slider__nav-two">
                    <div className="swiper-button-prev" id="main-slider__swiper-button-next">
                        <i className="fa fa-angle-right angle-left"></i>
                    </div>
                    <div className="swiper-button-next" id="main-slider__swiper-button-prev">
                        <i className="fa fa-angle-right"></i>
                    </div>
                </div> */}
      </div>
    </section>
  );
};

export default Carousel;
